import { module } from 'angular';
import templateBuilderJsonEditorDisplay from './builder/display.html';
import templateBuilderJsonEditorValidate from './builder/validate.html';

export default module('app').run(/* @ngInject */ (
	/** @type {import('angular').ITemplateCacheService} */ $templateCache,
) => {
	$templateCache.put('kform/components/jsoneditor/display.html', templateBuilderJsonEditorDisplay);
	$templateCache.put('kform/components/jsoneditor/validate.html', templateBuilderJsonEditorValidate);
});
